import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { TransactionStoreModel } from "@bitwarden/web-vault/app/models/store/transaction.store.model";
import { GlossScrollDirective } from "@bitwarden/web-vault/app/components/gloss-scroll/gloss-scroll.directive";

export interface VaultSameIdTransactionsDialogData {
  sharedId: string;
  transactions: TransactionStoreModel[];
}

@Component({
  selector: "app-vault-same-id-transactions-dialog",
  standalone: true,
  imports: [GlossScrollDirective, MatDialogModule, MatButtonModule],
  templateUrl: "./vault-same-id-transactions-dialog.component.html",
})
export class VaultSameIdTransactionsDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: VaultSameIdTransactionsDialogData) {}

  txJson(tx: TransactionStoreModel): string {
    try {
      return JSON.stringify(tx, null, 2);
    } catch {
      return String(tx.id);
    }
  }

  allJson(): string {
    try {
      return JSON.stringify(this.data.transactions, null, 2);
    } catch {
      return "";
    }
  }

  copyOne(tx: TransactionStoreModel): void {
    void navigator.clipboard?.writeText(this.txJson(tx)).catch(() => {});
  }

  copyAll(): void {
    void navigator.clipboard?.writeText(this.allJson()).catch(() => {});
  }
}
